import { Box, Flex, SkeletonText, Text } from "@chakra-ui/react";
import parse from "html-react-parser";
import { ReactNode } from "react";

export interface DescriptionProps {
  imageSrc?: string;
  cardHeading?: string;
  cardDescription?: string | ReactNode;
  showDetailedText?: boolean;
  showDescription?: boolean;
  isLoaded?: boolean;
  numberOfLines?: number;
}
export const Description = (props: DescriptionProps) => {
  const {
    imageSrc,
    cardHeading,
    cardDescription,
    showDetailedText,
    isLoaded,
    showDescription,
    numberOfLines
  } = props;

  return (
    <>
      {cardHeading && imageSrc && !showDetailedText && (
        <SkeletonText isLoaded={isLoaded} noOfLines={3}>
          <Flex direction="column">
            <Box
              whiteSpace="pre-wrap"
              fontWeight="normal"
              fontSize={
                showDescription && cardDescription && !imageSrc ? "md" : "sm"
              }
              noOfLines={3}
              lineHeight={3}
              data-testid="card-headingText"
            >
              <Text fontWeight="semibold">{cardHeading}</Text>

              {typeof cardDescription === "string"
                ? parse(cardDescription)
                : cardDescription}
            </Box>
          </Flex>
        </SkeletonText>
      )}
      {cardDescription && !imageSrc && !showDetailedText && (
        <SkeletonText isLoaded={isLoaded} noOfLines={3}>
          <Flex direction="column">
            <Text
              whiteSpace="pre-wrap"
              fontSize="md"
              noOfLines={3}
              lineHeight={6}
              data-testid="card-descriptionText"
            >
              {typeof cardDescription === "string"
                ? parse(cardDescription)
                : cardDescription}
            </Text>
          </Flex>
        </SkeletonText>
      )}
      {showDetailedText && imageSrc && cardHeading && (
        <SkeletonText isLoaded={isLoaded} noOfLines={3}>
          <Flex direction="column" gap={2}>
            <Text
              whiteSpace="pre-wrap"
              fontWeight="semibold"
              fontSize={
                showDescription && cardDescription && imageSrc ? "md" : "sm"
              }
              lineHeight={3}
              data-testid="card-headingText"
            >
              {cardHeading}
            </Text>
          </Flex>
        </SkeletonText>
      )}
      {cardDescription && showDetailedText && (
        <SkeletonText isLoaded={isLoaded} noOfLines={3}>
          <Flex direction="column" gap={2}>
            <Text
              whiteSpace="pre-wrap"
              fontSize="md"
              lineHeight={6}
              noOfLines={numberOfLines || 0}
              data-testid="card-descriptionText"
            >
              {typeof cardDescription === "string"
                ? parse(cardDescription)
                : cardDescription}
            </Text>
          </Flex>
        </SkeletonText>
      )}
    </>
  );
};
